import { nextInteger } from '~/boggle/engine/core'

type WeightedEntry = {
  weight: number
}

export function getPositiveSelectionWeight(weight: number) {
  if (!Number.isFinite(weight) || weight <= 0) {
    return 0
  }

  return Math.max(1, Math.floor(weight))
}

export function pickWeightedEntry<T extends WeightedEntry>(
  entries: readonly T[],
  rngState: number,
) {
  const eligibleEntries = entries.filter(
    entry => getPositiveSelectionWeight(entry.weight) > 0,
  )

  if (eligibleEntries.length === 0) {
    return null
  }

  const totalWeight = eligibleEntries.reduce(
    (sum, entry) => sum + getPositiveSelectionWeight(entry.weight),
    0,
  )
  const next = nextInteger(rngState, totalWeight)
  let remainingWeight = next.value

  for (const entry of eligibleEntries) {
    const weight = getPositiveSelectionWeight(entry.weight)
    if (remainingWeight < weight) {
      return {
        entry,
        rngState: next.rngState,
      }
    }

    remainingWeight -= weight
  }

  return {
    entry: eligibleEntries[eligibleEntries.length - 1]!,
    rngState: next.rngState,
  }
}
